import { handleGetWelcome } from '@/utils/Page/videoQA';
import { useEffect, useState } from 'react';
import s from './welcome.module.scss';
import { Display } from '@/components/Display/Display';
import preImg from '@/assets/images/mobile/pre_icon.webp';
import change_qa from '@/assets/images/video_qa/change_qa.webp';
import MyIcon from '@/components/MyIcon';
import { getEnvironment } from '@/utils/Mobile';
import { Tooltip } from 'antd';
const VideoQAWelcome = (props) => {
    const { onSubmit, courseId, courseType } = props;
    let env = getEnvironment();
    // 换一批起始偏移
    const [startIndex, setStartIndex] = useState(0);
    const [welcome, setWelcome] = useState([]);
    const [list, setList] = useState([]);
    const [expand, setExpand] = useState(false);

    const init = async () => {
        const res = await handleGetWelcome(courseId, courseType);
        if (res) {
            setWelcome(res);
            setStartIndex(0);
            setExpand(false);
        }
    };

    const toggleExpand = () => {
        setExpand(!expand);
    };

    const handleList = () => {
        if (!welcome?.length) return;
        let takeCount;
        // 收起：取3条；展开：最多取5条
        if (!expand) {
            takeCount = 3;
        } else {
            takeCount = 5;
        }
        const data = welcome.slice(startIndex, startIndex + takeCount);
        setList(data);
    };

    const onclickGuide = (item) => {
        onSubmit(item.question);
    };

    // 换一批，滚动偏移，循环
    const changeList = () => {
        const total = welcome.length;
        if (total <= 5) return;
        setStartIndex(prev => {
            // 收起一批3，展开一批5，跟随当前状态取数量
            const step = expand ? 5 : 3;
            const next = prev + step;
            return next >= total ? 0 : next;
        });
    };

    useEffect(() => {
        if (courseId && courseType) init();
    }, [courseId, courseType]);

    useEffect(() => {
        handleList();
    }, [expand, welcome, startIndex]);

    // 原始总数据大于5才显示换一批
    const showChangeBtn = welcome.length > 5;
    // 当前渲染列表>=3显示展开收起箭头
    const showExpandBtn = list.length >= 3;

    return (
        <Display show={welcome?.length > 0}>
            <div className={s['preset-question-wrap']}>
                <div className={s['preset-question-header']}>
                    <div className={s['preset-question-title']}>
                        <img src={preImg} alt="" /> 试试这样问我
                    </div>
                    <Display show={showChangeBtn}>
                        <div className={s['preset-question-change']} onClick={changeList}>
                            <img src={change_qa} alt="" /> 换一批
                        </div>
                    </Display>
                </div>
                {
                    list?.length ? (
                        <div className={s['preset-question-list']}>
                            {list.map((ele, idx) => {
                                return (
                                    <div
                                        key={idx}
                                        onClick={() => onclickGuide(ele)}
                                        className={`${s['preset-question-item']}`}
                                    >
                                        {env === 'pc' ? <Tooltip title={ele.question}><span className={s['text-ellipsis-2']}>{ele.question}</span></Tooltip> : <span className={s['text-ellipsis-2']}>{ele.question}</span>}
                                    </div>
                                );
                            })}
                        </div>
                    ) : null
                }
                <Display show={showExpandBtn}>
                    <div className={s['expand-box']} onClick={toggleExpand}>
                        <MyIcon
                            style={{ fontSize: '20px' }}
                            type={expand ? 'icon-a-Frame427319955' : 'icon-a-Frame4273199541'}
                        />
                    </div>
                </Display>
            </div>
        </Display>
    );
};
export default VideoQAWelcome;
